"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../../util/marshaler"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DeviceRepository = /*#__PURE__*/function () {
  function DeviceRepository(registry) {
    (0, _classCallCheck2["default"])(this, DeviceRepository);
    this._api = registry;
    (0, _autoBind["default"])(this);
  } // Brands retrieval.


  (0, _createClass2["default"])(DeviceRepository, [{
    key: "listBrands",
    value: function () {
      var _listBrands = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(appId) {
        var params,
            selector,
            result,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                selector = _args.length > 2 && _args[2] !== undefined ? _args[2] : [];
                _context.next = 4;
                return this._api.ListBrands({
                  routeParams: {
                    'application_ids.application_id': appId
                  }
                }, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 4:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('brands', result));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function listBrands(_x) {
        return _listBrands.apply(this, arguments);
      }

      return listBrands;
    }()
  }, {
    key: "getBrand",
    value: function () {
      var _getBrand = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId, brandId) {
        var selector,
            result,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selector = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : [];
                _context2.next = 3;
                return this._api.GetBrand({
                  routeParams: {
                    'application_ids.application_id': appId,
                    brand_id: brandId
                  }
                }, _objectSpread({}, _marshaler["default"].selectorToFieldMask(selector)));

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getBrand(_x2, _x3) {
        return _getBrand.apply(this, arguments);
      }

      return getBrand;
    }() // Models retrieval.

  }, {
    key: "listModels",
    value: function () {
      var _listModels = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(appId, brandId) {
        var params,
            selector,
            result,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                selector = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : [];
                _context3.next = 4;
                return this._api.ListModels({
                  routeParams: {
                    'application_ids.application_id': appId,
                    brand_id: brandId
                  }
                }, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 4:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadListResponse('models', result));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function listModels(_x4, _x5) {
        return _listModels.apply(this, arguments);
      }

      return listModels;
    }()
  }, {
    key: "getModel",
    value: function () {
      var _getModel = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(appId, brandId, modelId) {
        var selector,
            result,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                selector = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : [];
                _context4.next = 3;
                return this._api.GetModel({
                  routeParams: {
                    'application_ids.application_id': appId,
                    brand_id: brandId,
                    model_id: modelId
                  }
                }, _objectSpread({}, _marshaler["default"].selectorToFieldMask(selector)));

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getModel(_x6, _x7, _x8) {
        return _getModel.apply(this, arguments);
      }

      return getModel;
    }() // Templates retrieval.

  }, {
    key: "getTemplate",
    value: function () {
      var _getTemplate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(appId, version) {
        var result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.GetTemplate({
                  routeParams: {
                    'application_ids.application_id': appId,
                    'version_ids.brand_id': version.brand_id,
                    'version_ids.model_id': version.model_id,
                    'version_ids.firmware_version': version.firmware_version,
                    'version_ids.band_id': version.band_id
                  }
                });

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getTemplate(_x9, _x10) {
        return _getTemplate.apply(this, arguments);
      }

      return getTemplate;
    }() // Formatters retrieval.

  }, {
    key: "getUplinkDecoder",
    value: function () {
      var _getUplinkDecoder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(appId, version) {
        var result;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.GetUplinkDecoder({
                  routeParams: {
                    'application_ids.application_id': appId,
                    'version_ids.brand_id': version.brand_id,
                    'version_ids.model_id': version.model_id,
                    'version_ids.firmware_version': version.firmware_version,
                    'version_ids.band_id': version.band_id
                  }
                });

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getUplinkDecoder(_x11, _x12) {
        return _getUplinkDecoder.apply(this, arguments);
      }

      return getUplinkDecoder;
    }()
  }, {
    key: "getDownlinkDecoder",
    value: function () {
      var _getDownlinkDecoder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(appId, version) {
        var result;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.GetDownlinkDecoder({
                  routeParams: {
                    'application_ids.application_id': appId,
                    'version_ids.brand_id': version.brand_id,
                    'version_ids.model_id': version.model_id,
                    'version_ids.firmware_version': version.firmware_version,
                    'version_ids.band_id': version.band_id
                  }
                });

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getDownlinkDecoder(_x13, _x14) {
        return _getDownlinkDecoder.apply(this, arguments);
      }

      return getDownlinkDecoder;
    }()
  }, {
    key: "getDownlinkEncoder",
    value: function () {
      var _getDownlinkEncoder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(appId, version) {
        var result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.GetDownlinkEncoder({
                  routeParams: {
                    'application_ids.application_id': appId,
                    'version_ids.brand_id': version.brand_id,
                    'version_ids.model_id': version.model_id,
                    'version_ids.firmware_version': version.firmware_version,
                    'version_ids.band_id': version.band_id
                  }
                });

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getDownlinkEncoder(_x15, _x16) {
        return _getDownlinkEncoder.apply(this, arguments);
      }

      return getDownlinkEncoder;
    }()
  }]);
  return DeviceRepository;
}();

var _default = DeviceRepository;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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